import React from 'react';
import { FormattedMessage } from 'react-intl';

import css from './SizeModalTabs.css';

const Ski = ({ intl }) => {
  return (
    <div className={css.sections}>
      <div className={css.wrapper}>
        <h2 className={css.header}>
          <FormattedMessage id="SizesModal.SkiBootsTab.1sectionHeader" />
        </h2>
        <p className={css.content} dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'SizesModal.SkiBootsTab.1sectionContent' }) }} />
      </div>
      <div>
        <h2 className={css.header}>
          <FormattedMessage id="SizesModal.SkiBootsTab.2sectionHeader" />
        </h2>
        <div className={css.tableWrapper}>
          <table className={css.table}>
            <thead>
              <tr>
                <th><FormattedMessage id="SizesModal.SkiBootsTab.footSize" /></th>
                <th><FormattedMessage id="SizesModal.SkiBootsTab.bootSize" /></th>
              </tr>
            </thead>
            <tbody>
              <tr><td>24,0 - 24,9</td><td>25,0 - 25,5</td></tr>
              <tr><td>25,0 - 25,9</td><td>26,0 - 26,5</td></tr>
              <tr><td>26,0 - 26,9</td><td>27,0 - 27,5</td></tr>
              <tr><td>27,0 - 27,9</td><td>28,0 - 28,5</td></tr>
              <tr><td>28,0 - 28,9</td><td>29,0 - 29,5</td></tr>
              <tr><td>29,0 - 29,9</td><td>30,0 - 30,5</td></tr>
              <tr><td>30,0 - 30,9</td><td>31,0 - 31,5</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={css.wrapper}>
        <h2 className={css.header}>
          <FormattedMessage id="SizesModal.SkiBootsTab.3sectionHeader" />
        </h2>
        <p className={css.content}>
          <FormattedMessage id="SizesModal.SkiBootsTab.3sectionContentA" />
        </p>
        <div className={css.tableWrapper}>
        <table className={css.table}>
          <thead>
            <tr>
              <th><FormattedMessage id="SizesModal.SkiBootsTab.level" /></th>
              <th><FormattedMessage id="SizesModal.SkiBootsTab.manFlex" /></th>
              <th><FormattedMessage id="SizesModal.SkiBootsTab.womanFlex" /></th>
              <th><FormattedMessage id="SizesModal.SkiBootsTab.style" /></th>
            </tr>
          </thead>
          <tbody>
            <tr><td><FormattedMessage id="SizesModal.basic" /></td><td>70 - 90</td><td>60 - 80</td><td><FormattedMessage id="SizesModal.SkiBootsTab.styleBasic" /></td></tr>
            <tr><td><FormattedMessage id="SizesModal.medium" /></td><td>90 - 110</td><td>80 - 95</td><td><FormattedMessage id="SizesModal.SkiBootsTab.styleMedium" /></td></tr>
            <tr><td><FormattedMessage id="SizesModal.advanced" /></td><td>110 - 130</td><td>95 - 110</td><td><FormattedMessage id="SizesModal.SkiBootsTab.styleAdvanced" /></td></tr>
          </tbody>
        </table>
      </div>
      <p className={css.content}>
        <FormattedMessage id="SizesModal.SkiBootsTab.3sectionContentB" />
      </p>
    </div>
    </div>
  )
}

export default Ski;